class SizeCharts {
    constructor() {
      this.init();
    }
  
    async init() {
      const containers = document.querySelectorAll('[data-size-chart-url]');
      if (!containers.length) return;
      
      for (const container of containers) {
        const url = container.dataset.sizeChartUrl;
        const baseUrl = url.split('/edit')[0];
        const gidMatch = url.match(/gid=(\d+)/);
        const gid = gidMatch ? gidMatch[1] : '0';
        const csvUrl = `${baseUrl}/export?format=csv&gid=${gid}`;
        
        try {
          const response = await fetch(csvUrl);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const text = await response.text();
          const { table, hasDualUnits } = this.createTable(text);
          
          // Clear existing content
          container.innerHTML = '';
          
          if (hasDualUnits) {
            const toggle = this.createUnitToggle();
            container.appendChild(toggle);
          }
          container.appendChild(table);
        } catch (error) {
          console.error('Error:', error);
          container.innerHTML = '<p>Error loading size chart</p>';
        }
      }
    }

    createUnitToggle() {
      const wrapper = document.createElement('div');
      wrapper.className = 'size-chart-unit-toggle';
      wrapper.innerHTML = `
        <div class="unit-toggle-buttons">
          <button class="unit-toggle-btn active" data-unit="cm">cm</button>
          <button class="unit-toggle-btn" data-unit="in">in</button>
        </div>
      `;

      const buttons = wrapper.querySelectorAll('.unit-toggle-btn');
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          const table = e.target.closest('.size-chart-container').querySelector('table');
          const showInches = e.target.dataset.unit === 'in';
          
          // Update button states
          buttons.forEach(btn => btn.classList.remove('active'));
          e.target.classList.add('active');
          
          // Update cell visibility based on unit
          const inchCells = table.querySelectorAll('td[data-unit="in"], th[data-unit="in"]');
          const cmCells = table.querySelectorAll('td[data-unit="cm"], th[data-unit="cm"]');
          
          inchCells.forEach(cell => {
            cell.style.display = showInches ? '' : 'none';
          });
          
          cmCells.forEach(cell => {
            cell.style.display = showInches ? 'none' : '';
          });
        });
      });

      return wrapper;
    }
 
    createTable(csvData) {
      const rows = csvData.split('\n').map(row => 
        row.split(',').map(cell => cell.trim())
      ).filter(row => row.length > 0);
      
      const [headers] = rows;
      const hasDualUnits = this.checkForDualUnits(headers);
      
      const table = document.createElement('table');
      table.className = 'size-chart-table';
      
      // Process headers to add unit data attributes
      const processedHeaders = headers.map(header => {
        if (header.includes('(in)')) {
          return { text: header, unit: 'in' };
        } else if (header.includes('(cm)')) {
          return { text: header, unit: 'cm' };
        }
        return { text: header };
      });
      
      table.innerHTML = `
        <thead>
          <tr>${processedHeaders.map(h => 
            h.unit ? 
              `<th data-unit="${h.unit}" ${h.unit === 'in' ? 'style="display:none"' : ''}>${h.text}</th>` :
              `<th>${h.text}</th>`
          ).join('')}</tr>
        </thead>
        <tbody>
          ${rows.slice(1).map(row => `
            <tr>${row.map((cell, index) => {
              const unit = processedHeaders[index].unit;
              return unit ? 
                `<td data-unit="${unit}" ${unit === 'in' ? 'style="display:none"' : ''}>${cell}</td>` :
                `<td>${cell}</td>`;
            }).join('')}</tr>
          `).join('')}
        </tbody>
      `;
  
      return { table, hasDualUnits };
    }

    checkForDualUnits(headers) {
      const cmHeaders = headers.filter(h => h.includes('(cm)'));
      const inHeaders = headers.filter(h => h.includes('(in)'));
      return cmHeaders.length > 0 && inHeaders.length > 0;
    }
}
 
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new SizeCharts());
} else {
  new SizeCharts();
}